/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeComponentPages.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Component Pages Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, September 17, 2018 - 3:03 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      09/17/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const COMPONENTPAGE_LIST_CONTAINER_LOADED = 'COMPONENTPAGE_LIST_CONTAINER_LOADED';
export const COMPONENTPAGE_LIST_CONTAINER_UNLOADED = 'COMPONENTPAGE_LIST_CONTAINER_UNLOADED';

export const COMPONENTPAGE_LIST_TABLE_LOADED = 'COMPONENTPAGE_LIST_TABLE_LOADED';
export const COMPONENTPAGE_LIST_TABLE_UNLOADED = 'COMPONENTPAGE_LIST_TABLE_UNLOADED';

export const COMPONENTPAGE_LIST_CHANGE_GROUP_SELECT = 'COMPONENTPAGE_LIST_CHANGE_GROUP_SELECT';
export const COMPONENTPAGE_LIST_CHANGE_COMPONENT_SELECT = 'COMPONENTPAGE_LIST_CHANGE_COMPONENT_SELECT';

export const COMPONENTPAGE_SELECT_ROW = 'COMPONENTPAGE_SELECT_ROW';
export const COMPONENTPAGE_ADD = 'COMPONENTPAGE_ADD';
export const COMPONENTPAGE_EDIT = 'COMPONENTPAGE_EDIT';
export const COMPONENTPAGE_DELETE = 'COMPONENTPAGE_DELETE';
export const COMPONENTPAGE_OPEN_WARNING = 'COMPONENTPAGE_OPEN_WARNING';
export const COMPONENTPAGE_CLOSE_WARNING = 'COMPONENTPAGE_CLOSE_WARNING';


export const COMPONENTPAGE_EDIT_CONTAINER_LOADED = 'COMPONENTPAGE_EDIT_CONTAINER_LOADED';
export const COMPONENTPAGE_EDIT_CONTAINER_UNLOADED = 'COMPONENTPAGE_EDIT_CONTAINER_UNLOADED';

export const COMPONENTPAGE_EDIT_FORM_LOADED = 'COMPONENTPAGE_EDIT_FORM_LOADED';
export const COMPONENTPAGE_EDIT_FORM_UNLOADED = 'COMPONENTPAGE_EDIT_FORM_UNLOADED';
export const COMPONENTPAGE_EDIT_DATA_LOAD = 'COMPONENTPAGE_EDIT_DATA_LOAD';
export const COMPONENTPAGE_EDIT_CONTAINER_CANCEL = 'COMPONENTPAGE_EDIT_CONTAINER_CANCEL';

export const COMPONENTPAGE_EDIT_LOAD_GROUP_SELECT = 'COMPONENTPAGE_EDIT_LOAD_GROUP_SELECT';
export const COMPONENTPAGE_EDIT_DRAW_GROUP_SELECT = 'COMPONENTPAGE_EDIT_DRAW_GROUP_SELECT';
export const COMPONENTPAGE_EDIT_LOAD_COMPONENT_SELECT = 'COMPONENTPAGE_EDIT_LOAD_COMPONENT_SELECT';
export const COMPONENTPAGE_EDIT_DRAW_COMPONENT_SELECT = 'COMPONENTPAGE_EDIT_DRAW_COMPONENT_SELECT';


// WEBPACK FOOTER //
// ./src/constants/actionTypeComponentPages.js